export default __webpack_public_path__ + "static/media/ic_web_mstdata.96908481.png";